import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import DashboardLayout from '@/app/layouts/DashboardLayout';
import BackLink from '@/shared/components/BackLink';
import { routes } from '@/shared/routes';
import { SettingsSidebar, type SettingsSection } from '@settings';
import { AccountPanel, SecurityPanel  } from '@settings';

export default function SettingsPage() {
  const [activeSection, setActiveSection] = useState<SettingsSection>('account');

  return (
    <DashboardLayout>
      <div>
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <BackLink to={routes.app.root} />
            <h1 className="text-3xl font-bold text-slate-900">
              <FormattedMessage id="settings.heading" />
            </h1>
          </div>
          <div className="flex flex-col lg:flex-row lg:items-stretch">
            <aside className="w-full shrink-0 overflow-hidden rounded-xl border border-brand-100/80 bg-gradient-to-br from-brand-100/90 via-white/80 to-accent-100/80 p-2 shadow-lg shadow-brand-200/30 lg:w-1/4">
              <SettingsSidebar
                activeSection={activeSection}
                onSectionChange={setActiveSection}
              />
            </aside>
            <main className="flex-1 p-3 sm:p-8">
                {activeSection === 'account' && <AccountPanel />}
                {activeSection === 'security' && <SecurityPanel />}
            </main>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
